module.exports = ".fixed-bottom{\r\n    z-index: 3 !important;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.css
// module id = ./src/app/app.component.css
// module chunks = main